/**
 * Azure Avatar / TTS 設定，依病患 language + gender 對應
 * language: zh | en | vi | id
 * gender: 男 | 女 | 其他
 *
 * 注意：real-time avatar 的 character 與 style 必須合法搭配
 *   - lisa → casual-sitting
 *   - max  → casual（不支援 casual-sitting）
 */
const FEMALE_AVATAR = { character: 'lisa', style: 'casual-sitting' };
const MALE_AVATAR = { character: 'max', style: 'casual' };

const VOICES = {
  zh: { locale: 'zh-TW', female: 'zh-TW-HsiaoChenNeural', male: 'zh-TW-YunJheNeural' },
  en: { locale: 'en-US', female: 'en-US-AvaMultilingualNeural', male: 'en-US-AndrewMultilingualNeural' },
  vi: { locale: 'vi-VN', female: 'vi-VN-HoaiMyNeural', male: 'vi-VN-NamMinhNeural' },
  id: { locale: 'id-ID', female: 'id-ID-GadisNeural', male: 'id-ID-ArdiNeural' },
};

export function getAvatarPreset(language = 'zh', gender = '女') {
  const voice = VOICES[language] || VOICES.zh;
  const isMale = gender === '男';
  const avatar = isMale ? MALE_AVATAR : FEMALE_AVATAR;
  return {
    locale: voice.locale,
    voice: isMale ? voice.male : voice.female,
    character: avatar.character,
    style: avatar.style,
  };
}

export default getAvatarPreset;
